import React from "react";

import { float6Normalizer } from "validators";

import TextBlock from "../components/textBlock";

type transarmorData = {
	isTransarmorEnabled: string;
	transarmorMonthlyFee: string;
	transarmorPerTransactionFee: string;
};

type TransarmorViewProps = { data: transarmorData };

const TransarmorView = ({ data }: TransarmorViewProps) => {
	const {
		isTransarmorEnabled,
		transarmorMonthlyFee,
		transarmorPerTransactionFee,
	} = data || {};

	const isTransarmor = isTransarmorEnabled === "true" ? true : false;

	return (
		<>
			<TextBlock
				label="Transarmor"
				value={isTransarmor ? "Yes" : "No"}
				dataAutotest="transarmor"
			/>
			{isTransarmor && (
				<>
					<TextBlock
						label="Transarmor Monthly Fee"
						value={
							float6Normalizer(transarmorMonthlyFee, "$") ||
							"$0.00"
						}
						dataAutotest="transarmorMonthlyFee"
					/>
					<TextBlock
						label="Transarmor Per Transaction Fee"
						value={
							float6Normalizer(
								transarmorPerTransactionFee,
								"$",
							) || "$5.000000"
						}
						dataAutotest="transarmorPerTransactionFee"
					/>
				</>
			)}
		</>
	);
};

export default TransarmorView;
